"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envioSolicitudConverter = void 0;
const envioSolicitudConverter = {
    toFirestore(envioSolicitud) {
        return envioSolicitud;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const envio = {
            id: data.id ?? snapshot.id,
            empresa: data.empresa,
            anos: data.anos,
            fechaEnviada: data.fechaEnviada,
            fechaVencimiento: data.fechaVencimiento ?? "",
            numeroSolicitud: data.numeroSolicitud ?? "",
            pendiente: data.pendiente,
            paga: data.paga ?? false,
            esUnipersonal: data.esUnipersonal ?? true,
            fechaCarga: data.fechaCarga ?? 0,
            fechaPaga: data.fechaPaga ?? 0,
            fechaRecepcionCodigo: data.fechaRecepcionCodigo ?? 0,
            codigoInstalacionRecibido: data.codigoInstalacionRecibido ?? false,
            codigoInstalacion: data.codigoInstalacion ?? "",
            instalado: data.instalado ?? false,
            pdfStorage: data.pdfStorage ?? ""
        };
        return envio;
    }
};
exports.envioSolicitudConverter = envioSolicitudConverter;
